import Component from "@glimmer/component"

interface Signature {
  Args: {
    title: string
  }
}

export default class AddCardTitle extends Component<Signature> {}
declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::Menus::AddCard::Primary::Title": typeof AddCardTitle
  }
}
